<template>
  <FormSelectField
    v-model="internalValue"
    :field-path="fieldPath"
    :field-label="fieldLabel"
    :field-attrs="fieldAttrs"
    :errors="errors"
    :options="identificationTypes"
  />
</template>

<script setup>
import { computed } from "vue";
import { useGettext } from "vue3-gettext";
import FormSelectField from "@/components/form-fields/FormSelectField.vue";

const props = defineProps({
  modelValue: String,
  fieldPath: String,
  fieldAttrs: Object,
  fieldLabel: String,
  errors: Object
});
const emit = defineEmits(["update:modelValue"]);

const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value)
});

const { $gettext } = useGettext();
const identificationTypes = [
  { value: "faceToFace", label: $gettext("Face à face") },
  { value: "remote", label: $gettext("A distance") },
];
</script>
